const STORAGE_KEY = 'tablerTheme';

function applyIcons(theme: string) {
    document.querySelectorAll('#themeIcon, #themeIconMobile').forEach((icon) => {
        icon.className = theme === 'dark' ? 'ti ti-sun text-muted' : 'ti ti-moon text-muted';
        (icon as HTMLElement).style.fontSize = '1.25rem';
        icon.closest('a')?.setAttribute('title', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
    });
}

export function initThemeToggle() {
    const stored = localStorage.getItem(STORAGE_KEY) || 'dark';
    document.body.setAttribute('data-bs-theme', stored);
    applyIcons(stored);

    function toggle(event: Event) {
        event.preventDefault();
        const current = document.body.getAttribute('data-bs-theme') || 'dark';
        const next = current === 'dark' ? 'light' : 'dark';
        document.body.setAttribute('data-bs-theme', next);
        localStorage.setItem(STORAGE_KEY, next);
        applyIcons(next);
    }

    document.getElementById('themeToggle')?.addEventListener('click', toggle);
    document.getElementById('themeToggleMobile')?.addEventListener('click', toggle);
}
